<template>
    <span class="text-warning">
        <i
            class="fa fa-exclamation-triangle fa-lg icon-button"
            title="Detalhar reprovação"
            @click.stop="detalharReprovacao()"
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        solicitacaoReabertura: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {}
    },

    methods: {
        detalharReprovacao() {
            this.$swal({
                title: 'Justificativa da Reprovação',
                html: `${this.solicitacaoReabertura.detalheReprovacao}`,
                icon: 'warning'
            })
        }
    }
}
</script>
